exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!./../css/variables.css"), "");

// module
exports.push([module.id, ".message[data-v-8cdb1e98]{background:var(--aqua);padding:2px 5px;font-size:14px;display:inline-block;line-height:14px;position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-8cdb1e98","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/components/Report.vue
// module id = 595
// module chunks = 0